import { c as _c } from "react/compiler-runtime";
import { classNames, Flex } from "@opensea/ui-kit";
import { expandedSearchTransitionClassNames } from "./constants";
import { useExpandedSearchStore } from "./ExpandedSearchStore";
export function ExpandedSearchMenuPart(t0) {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const open = useExpandedSearchStore(_temp);
  const t1 = open ? "" : "opacity-0";
  let t2;
  if ($[3] !== className || $[4] !== t1) {
    t2 = classNames("w-full bg-bg-app", expandedSearchTransitionClassNames, t1, className);
    $[3] = className;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t2) {
    t3 = <Flex className={t2} {...props} />;
    $[6] = props;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp(state) {
  return state.open;
}